import * as React from "react"
import * as FontAwesome from "react-fontawesome"

interface IButtonComponentProps {
    uiTestAttribute: string
    disabled?: boolean
    className?: string
    key?: string
    id?: string
    style?: React.CSSProperties,
    children?: React.ReactNode
    onClick: () => void
}

interface IIconComponentProps {
    name: string
}

// Returns icon like: [< ButtonText]
export function IconCaretLeft() {
    return <span><i className="icon-caret-left" />&nbsp;</span>
}

// Returns icon like: [ButtonText >]
export function IconCaretRight() {
    return <span>&nbsp;<i className="icon-caret-right" /></span>
}

// Returns a font awesome icon
export function Icon({ name }: IIconComponentProps) {
    return <span><FontAwesome name={name} />&nbsp;</span>
}

export default function Button({
    disabled,
    className,
    key,
    id,
    style,
    uiTestAttribute,
    onClick,
    children
}: IButtonComponentProps) {
    return (
        <button
            style={style}
            type="button"
            disabled={disabled}
            className={className}
            key={key}
            id={id}
            onClick={() => onClick()}
            data-ui-test={uiTestAttribute}>
            <span>{children}</span>
        </button>
    )
}